function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

(function() {
const ele = document.querySelector('html');
const cs = getComputedStyle(ele);

const header = document.querySelector('#section-header');
const toolbar = document.querySelector('.CollectionToolbar');


let toolBarSticky = () => {
  const position = parseInt(cs.getPropertyValue('--header-height')) + parseInt(cs.getPropertyValue('--announcement-bar-height'));
  const startPos = Math.floor(position);
  if((window.pageYOffset >= startPos)){
    toolbar.classList.add('is-sticky');
  }else{
    toolbar.classList.remove('is-sticky');
  }
};

let headerCompact = () => {
  if((window.pageYOffset >= 20)){
    header.setAttribute('compact','');
    document.documentElement.style.setProperty('--header-height', header.clientHeight + 'px');
  }else{
    header.removeAttribute('compact');
    document.documentElement.style.setProperty('--header-height', header.clientHeight + 'px');
  }
};

window.addEventListener('DOMContentLoaded', () => {
  headerCompact();
  if(toolbar) toolBarSticky();
});

window.addEventListener('scroll', () => {
  headerCompact();
  if(toolbar) toolBarSticky();
});

async function updateCartCount() {
  const url = `${window.Shopify.routes.root}cart.js`;
  const response = await fetch(url);
  const json = await response.json();
  document.querySelector("#cart-item-count").innerText = json.item_count;
}

function minicartWatch() {
  const elementToObserve = document.querySelector("#sidebar-cart");
  const observer = new MutationObserver((mutations) => {
    updateCartCount();
  });
  observer.observe(elementToObserve, {subtree: false, childList: true});
}

minicartWatch();

})();